import React from "react";
import { FilterSection } from "@flights/search-ui";
import { useBudgetPerAdultFilterController } from "./useBudgetPerAdultFilter.controller.js";
import { InputSlider } from "@bookingcom/bui-react";
export const BudgetPerAdultFilter = () => {
    const { isFilterAvailable, title, min, max, value, ariaLabel, label, renderValue, renderTooltipValue, onChange, onChangeCommit, interval } = useBudgetPerAdultFilterController();
    if (!isFilterAvailable)
        return null;
    return (React.createElement(FilterSection, { attributes: { "data-testid": "budget_per_adult_filter" }, title: {
            text: title,
            tagName: "h3",
            attributes: { id: "budget_per_adult_filter" },
            variant: "strong_2"
        } },
        React.createElement(InputSlider, { min: min, max: max, value: value, interval: interval, name: "filters-budget-per-adult", attributes: { "data-testid": "search_filter_budget_per_adult_slider" }, ariaLabel: ariaLabel, label: label, onChange: ({ value }) => onChange(value), onChangeCommit: ({ value }) => onChangeCommit(value), renderValue: renderValue, renderTooltipValue: renderTooltipValue, ariaValuetext: renderTooltipValue })));
};
